import { REACT_QUERY_CONFIG } from '@/config/settings'
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { onQueryCacheError } from './catalogue-errors'

// The cache-level onError is the one hook that sees every query failure AFTER its retries are
// exhausted, wherever the query was observed from. It only acts on queries that opted in through
// `meta.catalogue` (catalogue-errors.ts), so the app's other queries keep their own handling.
export const queryClient = new QueryClient({
  ...REACT_QUERY_CONFIG,
  queryCache: new QueryCache({ onError: onQueryCacheError }),
})

export function ReactQueryProvider({ children }: { children: ReactNode }) {
  // No React Query Devtools floating button: it got in the way in the bottom-right corner (and it
  // showed up in dev with VITE_DEBUG=true too). It can be added back ad hoc when debugging.
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}
